export const categories = [
  {
    slug: 'zhumian',
    name: '助眠',
    icon: 'ri-moon-line',
    description: '轻柔的耳语、舒缓的触发音，帮助您快速进入深度睡眠，告别失眠困扰。',
    color: 'accent',
    imageSeq: 'cat-zhumian',
  },
  {
    slug: 'jieya',
    name: '解压',
    icon: 'ri-mental-health-line',
    description: '丰富的触发音效，有效缓解日常压力与焦虑情绪，让身心彻底放松。',
    color: 'primary',
    imageSeq: 'cat-jieya',
  },
  {
    slug: 'zhuanzhu',
    name: '专注',
    icon: 'ri-focus-2-line',
    description: '稳定的白噪音与自然音，屏蔽环境干扰，提升工作与学习效率。',
    color: 'secondary',
    imageSeq: 'cat-zhuanzhu',
  },
  {
    slug: 'baizaoyin',
    name: '白噪音',
    icon: 'ri-sound-module-line',
    description: '纯正的粉红噪音、棕色噪音等，为您营造沉浸式的声音环境。',
    color: 'accent',
    imageSeq: 'cat-baizaoyin',
  },
  {
    slug: 'ziranyin',
    name: '自然音',
    icon: 'ri-leaf-line',
    description: '雨声、海浪、森林鸟鸣等大自然的声音，带您回归宁静的自然怀抱。',
    color: 'primary',
    imageSeq: 'cat-ziranyin',
  },
  {
    slug: 'mingxiang',
    name: '冥想',
    icon: 'ri-candle-line',
    description: '颂钵、风铃、流水声等冥想音频，帮助您进入深度冥想与正念状态。',
    color: 'secondary',
    imageSeq: 'cat-mingxiang',
  },
];

export const featuredTracks = [
  {
    id: 'track-1',
    title: '深夜耳语助眠',
    category: 'zhumian',
    categoryName: '助眠',
    duration: '32:15',
    listens: 128500,
    imageSeq: 'track-01',
    description: '温柔的深夜耳语，配合轻柔的键盘敲击声，帮助您放松身心进入甜美梦乡。',
  },
  {
    id: 'track-2',
    title: '雨夜窗边白噪音',
    category: 'ziranyin',
    categoryName: '自然音',
    duration: '60:00',
    listens: 96300,
    imageSeq: 'track-02',
    description: '淅淅沥沥的雨声敲打窗棂，远处隐约的雷声，营造极致的雨天氛围。',
  },
  {
    id: 'track-3',
    title: '图书馆环境音',
    category: 'zhuanzhu',
    categoryName: '专注',
    duration: '45:00',
    listens: 87200,
    imageSeq: 'track-03',
    description: '翻书声、笔尖沙沙声，还原图书馆的安静氛围，助您高效学习工作。',
  },
  {
    id: 'track-4',
    title: '深海鲸歌冥想',
    category: 'mingxiang',
    categoryName: '冥想',
    duration: '40:30',
    listens: 65400,
    imageSeq: 'track-04',
    description: '深海中的鲸鱼歌声，配合悠远的水下回响，带您进入深层冥想状态。',
  },
  {
    id: 'track-5',
    title: '粉红噪音深度睡眠',
    category: 'baizaoyin',
    categoryName: '白噪音',
    duration: '60:00',
    listens: 112800,
    imageSeq: 'track-05',
    description: '经过专业调校的粉红噪音，频率分布均匀，适合深度睡眠与长时间放松。',
  },
  {
    id: 'track-6',
    title: '轻柔梳发解压音',
    category: 'jieya',
    categoryName: '解压',
    duration: '25:20',
    listens: 74300,
    imageSeq: 'track-06',
    description: '梳子轻柔划过发丝的酥麻声音，配合温柔的耳语，瞬间释放所有压力。',
  },
];

export const features = [
  {
    icon: 'ri-download-cloud-2-line',
    title: '无需下载',
    description: '所有音频在线播放，无需下载任何APP或文件，打开网页即可收听。',
  },
  {
    icon: 'ri-user-add-line',
    title: '无需注册',
    description: '完全免费开放，无需注册账号，无需登录，无任何使用门槛。',
  },
  {
    icon: 'ri-headphone-line',
    title: '高清音质',
    description: '所有音频采用高保真录制，为您提供极致的听觉享受。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '完美兼容手机、平板、电脑等设备，随时随地享受ASMR。',
  },
  {
    icon: 'ri-play-list-2-line',
    title: '海量内容',
    description: '涵盖助眠、解压、专注、冥想等六大场景，持续更新优质内容。',
  },
  {
    icon: 'ri-timer-line',
    title: '定时关闭',
    description: '支持定时关闭功能，设定播放时长后自动停止，安心入睡。',
  },
];

export const faqItems = [
  {
    question: 'ASMR免费网页真的完全免费吗？',
    answer: '是的，我们承诺所有音频内容完全免费，无需注册、无需下载。您可以随时随地打开网页免费收听所有ASMR音频。我们相信放松和优质睡眠是每个人的基本权利。',
  },
  {
    question: 'ASMR对睡眠真的有帮助吗？',
    answer: '大量研究和用户反馈表明，ASMR音频可以有效降低心率、缓解焦虑情绪，帮助人们更快进入睡眠状态。特别是白噪音和自然音类型，能有效屏蔽环境噪音干扰，营造适合睡眠的声音环境。',
  },
  {
    question: '可以在手机上使用吗？需要下载APP吗？',
    answer: '我们的网站完美适配手机、平板和电脑等各种设备。只需在手机浏览器中打开我们的网页，即可在线收听所有ASMR音频。无需下载任何APP，不占用手机存储空间，支持后台播放。',
  },
  {
    question: '音频可以下载保存吗？',
    answer: '我们的音频内容仅供在线收听使用。在线播放的方式既保护了内容创作者的权益，也让您无需占用设备存储空间。您只需在需要时打开网页即可随时收听。',
  },
  {
    question: '有哪些类型的ASMR音频？',
    answer: '我们提供六大类音频内容：助眠类（耳语、触发音）、解压类（各种触发音效）、专注类（白噪音、环境音）、白噪音类（粉红噪音、棕色噪音）、自然音类（雨声、海浪、鸟鸣）和冥想类（颂钵、风铃），满足您不同场景的需求。',
  },
  {
    question: '如何选择适合自己的ASMR音频？',
    answer: '不同人对声音的敏感度和偏好不同。我们建议您从助眠或自然音分类开始尝试，找到让自己最舒适的声音类型。您也可以浏览各分类下的热门音频，参考播放量和用户反馈来选择。',
  },
];

export const testimonials = [
  {
    name: '小雨',
    role: '长期失眠用户',
    content: '作为一个长期失眠的人，这个网站真的是我的救星！雨夜窗边的白噪音让我每晚都能在10分钟内入睡，已经用了半年多了，强烈推荐！',
    rating: 5,
  },
  {
    name: '清风明月',
    role: '程序员',
    content: '工作时一直戴耳机听图书馆环境音，能有效屏蔽办公室的各种杂音，工作效率提升了不少。关键是免费且不用注册，太良心了。',
    rating: 5,
  },
  {
    name: '暖暖',
    role: '大学生',
    content: '期末考试周全靠这个网站活着。专注分类的白噪音帮我熬过了无数个通宵复习的夜晚，音质很好，感谢ASMR免费网页！',
    rating: 5,
  },
];

export const articles = [
  {
    slug: 'asmr-ru-he-bang-zhu-shui-mian',
    title: 'ASMR如何帮助改善睡眠质量？科学解析与实用指南',
    summary: '深入探讨ASMR对睡眠的积极影响，从神经科学角度解析ASMR触发自主感觉经络反应的原理，以及如何选择适合自己的ASMR音频。',
    category: 'zhumian',
    categoryName: '助眠',
    date: '2026-07-28',
    readTime: '8分钟',
    imageSeq: 'article-01',
    content: `# ASMR如何帮助改善睡眠质量？科学解析与实用指南

## 什么是ASMR？

ASMR（Autonomous Sensory Meridian Response），即自主感觉经络反应，是指通过特定的视觉、听觉或触觉刺激，在头部、颈部、脊柱等部位产生一种令人愉悦的酥麻感。这种感觉类似于轻柔的抚触，能让人感到极度放松和舒适。

## ASMR与睡眠的科学关系

### 1. 降低心率与血压

研究表明，聆听ASMR音频时，人体的心率会显著降低。英国谢菲尔德大学的一项研究发现，ASMR体验者的心率平均每分钟降低3.14次，这与音乐放松法和正念冥想的放松效果相当。

### 2. 促进褪黑素分泌

ASMR音频中的舒缓声音能够降低交感神经系统的活跃度，激活副交感神经系统，从而促进褪黑素的自然分泌。褪黑素是调节睡眠周期的关键激素。

### 3. 减少睡前焦虑

美国睡眠医学会的研究指出，约40%的失眠问题与焦虑情绪有关。ASMR音频通过提供令人愉悦的感官体验，能够有效分散注意力，减轻睡前的负面思维循环。

## 如何选择适合自己的ASMR音频？

每个人的声音偏好都不同，建议从以下几类开始尝试：
- **轻声耳语**：适合喜欢亲密感和温柔声音的用户
- **自然白噪音**：适合容易被环境噪音干扰的用户
- **触发音**：如敲击声、梳发声，适合追求酥麻感的用户
- **纯音乐/颂钵**：适合冥想和深度放松的用户`,
  },
  {
    slug: 'bai-zao-yin-yu-fen-hong-zao-yin-qu-bie',
    title: '白噪音vs粉红噪音vs棕色噪音：有什么区别？该选哪个？',
    summary: '详细了解三种主流噪音的区别、适用场景和科学原理，帮助您选择最适合自己需求的噪音类型。',
    category: 'baizaoyin',
    categoryName: '白噪音',
    date: '2026-07-25',
    readTime: '6分钟',
    imageSeq: 'article-02',
    content: `# 白噪音vs粉红噪音vs棕色噪音：有什么区别？该选哪个？

## 三种噪音的科学定义

### 白噪音（White Noise）
白噪音在所有可听频率上具有相同的能量分布，听起来像收音机没信号时的"沙沙"声。由于高频成分较多，白噪音的声音相对尖锐。

### 粉红噪音（Pink Noise）
粉红噪音的能量随频率升高而递减（每倍频程降低3分贝），低频成分更为突出。听起来比白噪音更加柔和、低沉，类似瀑布声或稳定的雨声。

### 棕色噪音（Brown Noise）
棕色噪音的能量随频率升高衰减更快（每倍频程降低6分贝），具有最丰富的低频成分。声音最为深沉浑厚，类似远处的雷鸣或低沉的海洋声。

## 如何选择？

- **白噪音**：适合需要屏蔽高频环境噪音的场景，如办公室屏蔽人声
- **粉红噪音**：最为平衡的选择，适合大多数人的睡眠和放松需求
- **棕色噪音**：低频丰富，适合对高频声音敏感的用户，深沉浑厚让人安心

## 科学研究支持

2017年《人类神经科学前沿》的一项研究发现，粉红噪音能够增强深度睡眠阶段的慢波振荡，有助于改善记忆巩固。美国西北大学的研究也证实，粉红噪音有助于提高老年人的深度睡眠质量。`,
  },
  {
    slug: 'mei-ri-asmr-xi-guan-hao-chu',
    title: '每天听ASMR的5大好处：从解压到提升专注力',
    summary: '养成每日聆听ASMR的习惯，你会发现生活中的积极变化——从情绪管理到工作效率，全面解析ASMR的日常益处。',
    category: 'jieya',
    categoryName: '解压',
    date: '2026-07-20',
    readTime: '5分钟',
    imageSeq: 'article-03',
    content: `# 每天听ASMR的5大好处：从解压到提升专注力

## 1. 有效缓解压力与焦虑

每天花15-30分钟聆听ASMR音频，能够激活副交感神经系统，降低皮质醇水平。这是科学验证的减压方法，效果堪比轻度运动。

## 2. 改善睡眠质量

即使是白天聆听ASMR，也能帮助调节昼夜节律。如果能在睡前1小时聆听，效果更佳。

## 3. 提升专注力

环境白噪音能够提供稳定的背景声音，帮助大脑进入"心流"状态，特别适合需要长时间集中注意力的工作。

## 4. 情绪调节

ASMR的舒缓效果可以帮助管理情绪波动，在感到烦躁或低落时提供情绪出口。

## 5. 培养正念习惯

聆听ASMR本身是一种简单的正念练习，帮助你关注当下、觉察身心状态。`,
  },
  {
    slug: 'zi-ran-yin-asmr-zhi-yu',
    title: '自然音ASMR：为什么雨声和海浪声如此治愈？',
    summary: '探索大自然声音对人类心理的疗愈力量，以及如何在城市生活中通过自然音ASMR重获内心的宁静。',
    category: 'ziranyin',
    categoryName: '自然音',
    date: '2026-07-15',
    readTime: '7分钟',
    imageSeq: 'article-04',
    content: `# 自然音ASMR：为什么雨声和海浪声如此治愈？

## 进化心理学视角

人类在漫长的进化过程中，始终与自然为伴。雨声意味着安全的庇护所，海浪的节奏与母亲子宫中的声音相似——这些声音在基因记忆中意味着安全与舒适。

## 声音的节奏魔力

自然声音通常具有非线性的节奏变化，这种不可预测但有规律的声音模式，能够吸引大脑的注意力但又不会造成负担，让大脑进入一种"被动专注"的放松状态。

## 在城市中回归自然

现代城市生活中，我们被各种机械噪音包围。自然音ASMR提供了一个便捷的"声音绿洲"，让你在不离开城市的情况下，随时享受自然的安抚力量。

## 推荐自然音场景

- **下雨天**：适合阅读、午睡、安静的周末午后
- **海浪声**：适合冥想、瑜伽、压力释放
- **森林鸟鸣**：适合清晨唤醒、创意工作
- **溪水潺潺**：适合专注工作、学习`,
  },
  {
    slug: 'asmr-ming-xiang-ru-men',
    title: 'ASMR冥想入门指南：零基础也能学会的声音冥想',
    summary: '不需要任何经验，只需一副耳机和15分钟时间，跟随本指南开始您的ASMR冥想之旅。',
    category: 'mingxiang',
    categoryName: '冥想',
    date: '2026-07-10',
    readTime: '6分钟',
    imageSeq: 'article-05',
    content: `# ASMR冥想入门指南：零基础也能学会的声音冥想

## 准备工作

1. 找一个安静舒适的位置
2. 准备一副音质不错的耳机（头戴式效果最佳）
3. 设定15-30分钟不被打扰的时间
4. 调整到舒适的姿势——可以坐着或躺着

## 三步入门法

### 第一步：身体扫描（3分钟）
闭上眼睛，从头顶开始，慢慢将注意力移到脚趾，觉察每个部位的感受。

### 第二步：声音专注（10分钟）
打开颂钵或流水冥想音频，将全部注意力放在声音上。感受声音的振动、回响和变化。

### 第三步：回到当下（2分钟）
慢慢将注意力回到呼吸，感受身体的重量，缓缓睁开眼睛。

## 常见问题

Q：冥想时总是走神怎么办？
A：走神是正常的。当你发现走神时，温柔地把注意力拉回声音即可，不需要自责。

Q：听不到"酥麻感"正常吗？
A：完全正常。ASMR感受因人而异，即使没有酥麻感，放松效果依然存在。`,
  },
];

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '助眠', href: '/category/zhumian' },
  { label: '解压', href: '/category/jieya' },
  { label: '专注', href: '/category/zhuanzhu' },
  { label: '白噪音', href: '/category/baizaoyin' },
  { label: '自然音', href: '/category/ziranyin' },
  { label: '冥想', href: '/category/mingxiang' },
  { label: '关于我们', href: '/about' },
];